<template>
  <section class="notice_edit">
    <help-center-bar class="tab"></help-center-bar>
    <div class="container">
      <div class="helpCenter">
          <s-title-header   :mainTitle='docTitle' subTitle="更新记录" :description="titleDes"></s-title-header>
          <s-button id="newbtn" v-if="$store.getters.roler==='admin'" @click.native="skip_NoticeEdit('add')" width=0.68 height=0.2 color="#fff" ave="#276BEE" textWord="发布更新" lineHeight=0.2></s-button>

      </div>
      <div class="edit_btn">
        <div class="fl" v-show="btnStatus">
          <span class="save">
            <s-button class="editbtn" v-if="$store.getters.roler==='admin'"  @click.native="skip_NoticeEdit" width=0.68 height=0.2 color="#276BEE" ave="#fff" border="solid 1px #276BEE " textWord="编辑"  lineHeight=0.2></s-button>
          </span>
          <span class="cancel">
            <s-button class="cancelbtn"  v-if="$store.getters.roler==='admin'" @click.native="deletePro" width=0.68 height=0.2 color="rgb(238, 60, 39)" ave="#fff" border="solid 1px rgb(238, 60, 39) " textWord="删除" lineHeight=0.2></s-button>
          </span>
        </div>
      </div>
      <div class="content_area">
        <!-- 左侧导航 -->
        <div class="le">
          <div class="catalogue">
            <ul>
              <li class="point" @click="apperContent(item)" :class="{active: activeId === item._id}" v-for="item in versionList" :key='item._id'>{{item.Versions}}版本更新&nbsp;&nbsp;<span>{{fmtTime(item.CreatedAt)}}</span></li>
              <!-- <li>2.3.5版本更新<span>2018-12-05</span></li>
              <li>2.3.5版本更新<span>2018-12-05</span></li> -->
            </ul>
          </div>
        </div>
        <div class="ri">
          <!-- 中间编辑框 -->
          <div v-show="!isShowPic" class="edit_content" v-html="upContents"></div>
          <div class="pic" v-show="isShowPic" ><img src="../assets/noData.png" alt=""></div>
          <!-- 右侧设置框 -->
        </div>
      </div>
      <!-- <Tips titleText='您确定要删除这项记录吗' widthSize="150" v-if="apperTips"></Tips> -->
    </div>
  </section>
</template>
<script>
import Api from '@/api/api'
import Tips from '@/components/Tips'
import HelpCenterBar from '@/components/HelpCenterBar'
import STitleHeader from '@/components/STitleHeader'
import SButton from '@/components/SButton'

export default {
  /******************************************
  ** 组件名称
  * @description 组件描述
  * @author ah
  *****************************************
  prop1          <type>            <属性描述>
  *****************************************/
  name: 'UpdateCatalogue',
  components: {HelpCenterBar, STitleHeader, SButton, Tips},
  props: {},
  data () {
    return {
      upContents: '',
      versionList: [],
      noticeId: '',
      docTitle: '',
      titleDes: '',
      btnStatus: false, // 如果无内容不出现
      apperTips: true,
      activeId: 0,
      isShowPic: false
    }
  },
  computed: {},
  created () {
    this.getNotice()
    this.getProInfo()
    this.scroll()
  },
  methods: {
    scroll () {
      // 滑动到一定高度,固定tab栏
      $(window).scroll(function () {
        let scrollDistance = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        // console.log(scrollDistance)
        if (scrollDistance >= 0) {
          $('.tab').addClass('fixtab')
        } else {
          $('.tab').removeClass('fixtab')
        }
        if (scrollDistance >= 25) {
          $('#newbtn ').addClass('fixnewbtn')
          $('.edit_btn').css('backgroundColor', '')
        } else {
          $('#newbtn ').removeClass('fixnewbtn')
        }
        if (scrollDistance >= 120) {
          $('.edit_btn').addClass('fixbtn')
          $('.helpCenter').css('backgroundColor', '#fff')
        } else {
          $('.edit_btn').removeClass('fixbtn')
        }
      }
      )
    },
    // 获取产品信息
    getProInfo () {
      Api.getDoc(this.$route.params.id).then(res => {
        // console.log('=======')
        // console.log(res)
        if (res.status === 200) {
          // console.log(res.data)
          this.docTitle = res.data.Result[0].Name
          this.titleDes = res.data.Result[0].Description
        }
      })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取更新信息列表
    getNotice () {
      // console.log(this.$route.params.id) // 产品ID
      Api.getNoticeList(this.$route.params.id).then(res => {
        // console.log(res)//
        if (res.status === 200) {
          // 判断是否有数据,没有就发布更新且编辑删除按钮消失
          let data = res.data.Result

          // console.log('更新记录结果')
          // console.log(data)
          this.$store.dispatch('setRoler', res.data.role)
          if (data.length !== 0) {
            this.btnStatus = true
            this.versionList = data
            this.noticeId = data[0]._id
            this.activeId = data[0]._id
            if ($.trim(data[0].Contents).length === 0) {
              this.isShowPic = true
            } else {
              this.isShowPic = false
              this.upContents = data[0].Contents
            }
          } else {
            this.versionList = []
            this.isShowPic = true
            // this.upContents = '<h2>请发布更新吧</h2>'
          }
        }
      })
    },
    // 点击编辑,跳转到通知编辑页面
    skip_NoticeEdit (item) {
      // console.log(item)

      // console.log('this.noticeId')
      // console.log(this.noticeId)

      this.$router.push({
        name: 'NoticeEdit',
        params: {
          id: item === 'add' ? 'add' : this.noticeId,
          pid: this.$route.params.id
        }
      })
      // this.$router.push('/NoticeEdit')
    },
    // 点击目录显示对应的内容
    apperContent (item) {
      // this.getNotice()
      this.upContents = item.Contents
      this.noticeId = item._id
      // console.log(item._id)
      this.activeId = item._id
    },
    // 删除
    deletePro () {
      // console.log(this.noticeId)
      Api.deleteNotice(this.noticeId).then(res => {
        console.log(res)//
        if (res.status === 200) {
          this.upContents = ''
          this.noticeId = ''
          this.isShowPic = true
          this.getNotice()
          // console.log(this.versionList)
        }
      })
    },
    // 时间格式化
    fmtTime (time) {
      let arrA = time.split('T')
      // let arrB = arrA[1].split('.')
      // let hms = arrB[0]
      let ymd = arrA[0]
      let str = ymd
      return str
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  // width: 1080px;
  width: 88%;
  margin:0 auto;
  // height: 500px;
  .helpCenter{
    // position: relative;
    // padding:80px 0 0 0;
    // width: 100%;
    // height: 200px;
    // display:flex;
    // justify-content: space-between;
      // padding:0.4rem 0;
      padding-top:0.6rem;
      width: 100%;
      height: auto;
      line-height: auto;
      display: flex;
      justify-content: space-between;
    .newbtn .right{
      margin-bottom:0px;
    }
    .fixbtn{
      position: fixed;
      top: 150px;
      left: 413px;
      z-index:999;
    }
  }
  .edit_btn{
      // width: 1080px;
      width: 100%;
      height:0.2rem;
      // margin-top:-60px;
      // margin-bottom:50px;
      // position:absolute;
      // top:270px;
      // left:0px;
      .cancel,.save{
        display: inline-block;
        transition: all 1s;
      }
      .fl{
        float:right;
      }
  }
  .content_area{
    width: 100%;
    margin-top:0.2rem;
    position:relative;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    .le{
      width: 30%;
      box-sizing: border-box;
      margin-right:0.26rem;
      .catalogue{
        width: 1.1rem;
        // width: 220px;
        height: 1000px;
        border-right: solid 1px #EAEAEA;

        li{
          width: 100%;
          // height: 47px;
          // line-height: 47px;
          height: 0.24rem;
          line-height:0.24rem;
          text-align:center;
          // overflow: hidden;
          white-space:nowrap;
          // text-overflow: ellipsis;
          // font-size:13px;
          font-size:0.06rem;

          font-weight: 300;
          color: #111111;
        }
        .active{
          background-color: #f0f6ff ;
          border-right:solid 3px #276BEE;
        }
      }
    }
    .ri{
      width: 64%;
      box-sizing: border-box;
      .edit_content{
        width:76%;
        height: 1000px;
      // background-color: lightseagreen;
        padding-bottom:0.5rem;
        h1{
           font-size:0.1rem!important;
        }
      }
      .pic {
          width:0.77rem ;
          height: 0.7rem;
          // position:absolute;
          margin:0 auto;
          // position: absolute;
          // top: 200px;
          // left: 600px;
          margin-top:26%;
          margin-left:36%;
          img{
            width: 100%;
            height: 100%;
          }

        }
    }

  }
}
.fixtab{
  position: fixed;
  top: 0px;
  left: 0px;
  z-index:9999;
  background-color: #F7F7F7;
}

</style>



// WEBPACK FOOTER //
// src/pages/UpdateCatalogue.vue